import script from "./EntityHistoryView.vue?vue&type=script&setup=true&lang=js"
export * from "./EntityHistoryView.vue?vue&type=script&setup=true&lang=js"

import "./EntityHistoryView.vue?vue&type=style&index=0&id=8f7c1eda&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f7c1eda"]])

export default __exports__